import styles from './GratuityDetail.css'
import GratuityForm from './GratuityForm'
import {connect} from 'react-redux'
import {submitFormCreate, submitFormUpdate, submitFormCreateAllOutlet} from 'actions/library/gratuity'
import * as mpLibraryGratuity from 'mixpanel/library/gratuity'

class GratuityDetail extends React.Component {
  render () {
    return (<div className={styles.wrapper}>
      <GratuityForm onSubmit={this._onSubmit} />
    </div>)
  }

  _onSubmit = (values) => {
    const {dispatch, gratuities} = this.props
    // we must delete the 'action' property so it doesn't sent to server.
    if (values.action === 'save') {
      delete values.action
      if (values.id) {
        mpLibraryGratuity.libraryGratuityUpdate({newValue: values})
        dispatch(submitFormUpdate(values.id, values, gratuities))
      } else {
        mpLibraryGratuity.libraryGratuityCreate({values, isAllOutlet: false})
        dispatch(submitFormCreate(values, gratuities))
      }
    } else {
      delete values.action
      mpLibraryGratuity.libraryGratuityCreate({values, isAllOutlet: true})
      dispatch(submitFormCreateAllOutlet(values, gratuities))
    }
  }
}

function mapStateToProps (state) {
  const {gratuities} = state.library.gratuity
  return {
    gratuities
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

export default connect(mapStateToProps, mapDispatchToProps)(GratuityDetail)



// WEBPACK FOOTER //
// ./app/pages/Library/Gratuity/GratuityDetail/GratuityDetail.js